<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold">“This is great - we need more of this.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reflects <span class="font-bold">trust in both directions.</span>
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      You don’t just tolerate challenge - you value it. And your team knows it.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a Fast Attack team, speaking up isn’t just accepted - it’s expected.
      You’re modeling a culture that treats disagreement as a path to better
      decisions.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Ask: <span class="italic"
        >Are others seeing this challenge modeled and rewarded?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Shine a light on courageous thinking in public forums to normalize dissent
      as leadership behavior.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold">“Let’s take this offline.” </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This response often masks <span class="font-bold"
        >discomfort with conflict in front of others.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      You may want to address it - but not here, not now.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      In high-pressure environments, timing matters - but deferral can signal
      danger. Delayed clarity often leads to quiet confusion.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Instead of deflecting, pause and explore. Ask: <span class="italic"
        >“Can we hear this out for two minutes?”
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Build your tolerance - and your team’s - for public challenge done well.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold"
        >“Do they even understand the bigger picture?”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This signals <span class="font-bold"
        >defensiveness and power imbalance.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      The instinct is to assume misunderstanding - not curiosity or
      contribution.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On elite crews, no idea is dismissed without examination. The higher you
      lead, the more clarity you owe.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      When challenged, flip the script: <span class="italic"
        >What are they seeing that I’m not?
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Use curiosity as your first move, not judgment - and you’ll model the
      behavior you want to scale.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold">“That won’t happen again.”</span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a trust shutdown - <span class="bold"
        >your reaction teaches silence.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Whether intended or not, the message is: <span class="italic"
        >This isn’t safe territory.</span
      >
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a sub, punishing feedback means future issues go unspoken - until it’s
      too late.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Reopen the door. Follow up with the person privately and say: <span
        class="italic"
        >“You had a point - let’s explore it.”
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      One reversal like that can reignite safety for the whole team.
    </p>
  {/if}
</div>
